
























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Types extends Vue {
  // props
  @Prop(String) readonly dataAmount: string | undefined;
  @Prop(String) readonly dataType: string | undefined;
  @Prop({ required: true, type: Array }) readonly dataSource!: DateSourceItem[];
  @Prop(String) readonly classPrefix?: string;
  // methods
  liClass(item: DateSourceItem) {
    if (this.dataType === "-") {
      return {
        selectedOut: this.dataType === item.value,
        [this.classPrefix + "-tabs-item"]: this.classPrefix,
      };
    } else if (this.dataType === "+") {
      return {
        selectedIn: this.dataType === item.value,
        [this.classPrefix + "-tabs-item"]: this.classPrefix,
      };
    }
  }
  select(item: DateSourceItem) {
    this.$emit("update:dataType", item.value);
  }
}
